import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-stop-hold-migrate-dialog',
    template: require('./stopHoldMigrateDialog.html')
})
export class StopHoldMigrateDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<StopHoldMigrateDialogComponent>) public dialogRef: MatDialogRef<StopHoldMigrateDialogComponent>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }


}

